import React from 'react'
import CustomLink from '../CustomLink'
import { CUSTOM_LINK_TYPES } from 'modules/settings/model'

import './style.css'

const CustomLinksList = ({ onEditCustomLink, onRemoveCustomLink, customLinks }) => {
  return (
    <div className="custom-links-list-wrapper">
      <ul className="custom-links-list">
        {customLinks.map((customLink, i) => {
          return customLink.type === CUSTOM_LINK_TYPES['4'] ?
            (
              <CustomLink
                key={`cl-${i}`}
                displayText={customLink.displayText}
                onEditClick={() => onEditCustomLink(customLink)}
                onRemoveClick={() => onRemoveCustomLink(customLink)}
              />
            ) : null
        })}
      </ul>
    </div>
  )
}

export default CustomLinksList